import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiHome, FiPhone, FiMail } = FiIcons;

const Success = () => {
  return (
    <div className="pt-16 min-h-screen bg-warm-50 flex items-center justify-center py-12 px-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }} 
        animate={{ opacity: 1, scale: 1 }} 
        className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl p-10 md:p-16 text-center border border-warm-100"
      >
        <div className="bg-primary-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8">
          <SafeIcon icon={FiCheckCircle} className="h-12 w-12 text-primary-600" />
        </div>
        
        <h1 className="text-4xl font-bold text-warm-900 mb-6">
          Candidatura Inviata!
        </h1>
        
        <p className="text-xl text-warm-700 mb-10 leading-relaxed">
          Hai candidato il tuo immobile con successo!<br />
          Un esperto di <span className="font-bold text-primary-600">Castello SRL</span> sarà da te al più presto!
        </p>

        <div className="bg-warm-50 rounded-2xl p-8 mb-10 text-left space-y-4">
          <div className="flex items-center space-x-4">
            <div className="bg-white p-2 rounded-lg shadow-sm"><SafeIcon icon={FiPhone} className="text-primary-600" /></div>
            <span className="text-warm-700">Ti contatteremo entro 24 ore telefonicamente.</span>
          </div>
          <div className="flex items-center space-x-4">
            <div className="bg-white p-2 rounded-lg shadow-sm"><SafeIcon icon={FiMail} className="text-primary-600" /></div>
            <span className="text-warm-700">Riceverai una conferma via email con i dettagli.</span>
          </div>
        </div>

        <Link to="/" className="inline-block bg-primary-600 text-white px-10 py-4 rounded-xl font-bold hover:bg-primary-700 transition-all shadow-lg">
          Torna alla Home
        </Link>
      </motion.div>
    </div>
  );
};

export default Success;